import { makeStyles } from '@mui/styles';

const Style = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
  autocompleteWhite: {
    backgroundColor: theme.palette.background.default,
    borderRadius: 4,
  },
  // Skeleton lines stand in for the whole field. `variant="text"` derives its
  // height from the font size, so these mirror the label / value / helper-text
  // rhythm of the loaded field without redrawing any input chrome.
  loadingLabelLine: {
    fontSize: '0.75rem',
  },
  loadingValueLine: {
    fontSize: '1.5rem',
  },
  loadingDescriptionLine: {
    fontSize: '0.75rem',
  },
  retryLink: {
    verticalAlign: 'baseline',
  },
}));

export default Style;
